import { ErrorBody } from '@services/productInventory';
import { type PropsWithChildren } from 'react';
import styles from './ErrorList.module.scss';

interface ErrorListProps {
  label: string;
  errors: ErrorBody[] | null;
}

export function ErrorList({ label, errors, children }: PropsWithChildren<ErrorListProps>) {
  return (
    <div className={styles.errors}>
      <ul className={styles.list}>
        <li>{label}</li>
        {errors && Object.values(errors).map(({ source, message }) => <li key={`${source}-${message}`}>{message}</li>)}
      </ul>
      {children}
    </div>
  );
}
